import { expertise } from "../../utils/websiteData";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";

const Experience = () => {
  const { frontend, backend } = expertise;
  return (
    <section id="experience">
      <h5>What Skills I have</h5>
      <h2>My Experience</h2>
      <div className="container experience-container">
        <div className="experience-frontend">
          <h3>Frontend Development</h3>
          <div className="experience-content">
            {frontend.map((item, index) => {
              return (
                <article key={index} className="experience-details">
                  <BsPatchCheckFill className="experience-icon" />
                  <div>
                    <h4>{item.language}</h4>
                    <small className="text-light">
                      {item.levelOfExperience}
                    </small>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
        <div className="experience-backend">
          <h3>Backend Development</h3>
          <div className="experience-content">
            {backend.map((item, index) => {
              return (
                <article key={index} className="experience-details">
                  <BsPatchCheckFill className="experience-icon" />
                  <div>
                    <h4>{item.language}</h4>
                    <small className="text-light">
                      {item.levelOfExperience}
                    </small>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default Experience;
